import {
  CREATE_MEDICAL_SUPLIES_FAIL,
  CREATE_MEDICAL_SUPLIES_REQUEST,
  CREATE_MEDICAL_SUPLIES_SUCCESS,
  FETCH_MEDICAL_SUPLIES_FAIL,
  FETCH_MEDICAL_SUPLIES_REQUEST,
  FETCH_MEDICAL_SUPLIES_SUCCESS,
  UPDATE_MEDICAL_SUPLIES_FAIL,
  UPDATE_MEDICAL_SUPLIES_REQUEST,
  UPDATE_MEDICAL_SUPLIES_SUCCESS,
} from "../../ActionType/MedicalSupliesTypes/MedicalSupliesTypes";

export const getMedicalSupliesReducer = (
  state = { loading: true, medicalSuplies: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_MEDICAL_SUPLIES_REQUEST:
      return {
        loading: true,
        medicalSuplies: action.payload,
      };
    case FETCH_MEDICAL_SUPLIES_SUCCESS:
      return {
        loading: false,
        medicalSuplies: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case FETCH_MEDICAL_SUPLIES_FAIL:
      return {
        loading: false,
        medicalSuplies: action.payload,
        error: "",
      };
    default:
      return state;
  }
};

export const createMedicalSupliesReducer = (
  state = { loading: true, medicalSuplies: [], error: "" },
  action
) => {
  switch (action.type) {
    case CREATE_MEDICAL_SUPLIES_REQUEST:
      return {
        loading: true,
        medicalSuplies: action.payload,
      };
    case CREATE_MEDICAL_SUPLIES_SUCCESS:
      return {
        loading: false,
        medicalSuplies: action.payload,
        error: "",
      };
    case CREATE_MEDICAL_SUPLIES_FAIL:
      return {
        loading: false,
        medicalSuplies: action.payload,
        error: "",
      };
    default:
      return state;
  }
};

export const updateMedicalSupliesReducer = (
  state = { loading: true, medicalSuplies: [], error: "" },
  action
) => {
  switch (action.type) {
    case UPDATE_MEDICAL_SUPLIES_REQUEST:
      return {
        loading: true,
        medicalSuplies: action.payload,
      };
    case UPDATE_MEDICAL_SUPLIES_SUCCESS:
      return {
        loading: false,
        medicalSuplies: action.payload,
        error: "",
      };
    case UPDATE_MEDICAL_SUPLIES_FAIL:
      return {
        loading: false,
        medicalSuplies: action.payload,
        error: "",
      };
    default:
      return state;
  }
};
